<template>
	<div class="home-section">
		<div class="home-section1 swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide">
					<img src="images/home-scroll-section1-pc-01.jpg" alt="" />
				</div>
				<div class="swiper-slide">
					<img src="images/home-scroll-section1-pc-04.jpg" alt="" />
				</div>
				<div class="swiper-slide">
					<img src="images/home-scroll-section1-pc-02.jpg" alt="" />
				</div>
				<div class="swiper-slide">
					<img src="images/home-scroll-section1-pc-03.jpg" alt="" />
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>
		<div class="home-section2">
			<div class="header">我们能为你做什么？</div>
			<div class="aside">让照护有温度，让护理更智慧</div>
			<div class="section">
				<div class="item" v-on:click="scrollToDomFun('anchorPoint1')">
					<div class="header">医</div>
					<div class="section">首诊服务、陪诊配药、在线复诊</div>
					<div class="footer">First Consultation Service, accompany<br /> consultation dispensing, on-line follow-up</div>
				</div>
				<div class="item" v-on:click="scrollToDomFun('anchorPoint2')">
					<div class="header">护</div>
					<div class="section">在院照护、居家护理、母婴护理</div>
					<div class="footer">In-hospital care,<br /> home care, maternal and infant care</div>
				</div>
				<div class="item" v-on:click="scrollToDomFun('anchorPoint3')">
					<div class="header">康</div>
					<div class="section">康复理疗护理、术后康复</div>
					<div class="footer">Physical therapy, <br />surgical hand rehabilitation</div>
				</div>
				<div class="item" v-on:click="scrollToDomFun('anchorPoint4')">
					<div class="header">养</div>
					<div class="section">社区/居家养老</div>
					<div class="footer">Community / Home Care</div>
				</div>
				<div class="item" v-on:click="scrollToDomFun('anchorPoint5')">
					<div class="header">托</div>
					<div class="section">护理服务托管</div>
					<div class="footer">Nursing Service Trusteeship</div>
				</div>
				<div class="item" v-on:click="scrollToDomFun('anchorPoint6')">
					<div class="header">培</div>
					<div class="section">护工培训</div>
					<div class="footer">Nurse Training</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint1"></div>
		<div class="home-section3">
			<div class="left-view">
				<img src="images/home-section3-pc-01.png" alt="">
			</div>
			<div class="right-view">
				<div class="header">
					<span>医疗服务 / </span>Medical Services
				</div>
				<div class="section">
					<div class="item">
						<div class="line"></div>
						<div class="text">陪诊配药</div>
					</div>
					<div class="item">
						<div class="line"></div>
						<div class="text">首诊服务</div>
					</div>
					<div class="item">
						<div class="line"></div>
						<div class="text">在线复诊</div>
					</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint2"></div>
		<div class="home-section4">
			<img class="aside" src="images/home-section4-pc-01.jpg" alt="">
			<div class="header">
				<div class="left-view"></div>
				<div class="right-view"></div>
			</div>
			<div class="section">
				<div class="left-view">
					<div class="header">
						<span>护理服务 / </span>Nursing Services
					</div>
					<div class="section">
						适用于处于术前及术后短期护理需求的住<br />
						院期护理，具有一定自理能力或无自理能<br />
						力的照护对象。
					</div>
					<div class="footer"></div>
				</div>
				<div class="right-view">
					<div class="item">
						<img class="left-view" src="images/home-section4-pc-02.png" alt="">
						<div class="right-view">
							<div class="header">在院照护</div>
							<div class="section">
								适用于处于术前及术后短期护理需求的住院期护理，具有一定自理能力或无自理能力的照护对象。
							</div>
						</div>
					</div>
					<div class="item">
						<img class="left-view" src="images/home-section4-pc-03.png" alt="">
						<div class="right-view">
							<div class="header">母婴护理</div>
							<div class="section">
								产褥期（顺/剖）产妇，小产（流产）的女性，特体产妇（三高、高危龄）及医学许可范围内可生育但需要特殊护理产妇的日常生活及专业照护和新生儿的日常护理。
							</div>
						</div>
					</div>
					<div class="item">
						<img class="left-view" src="images/home-section4-pc-04.png" alt="">
						<div class="right-view">
							<div class="header">居家照护</div>
							<div class="section">有慢性疾病，具有一定的自理能力。</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint3"></div>
		<div class="home-section5">
			<div class="left-view">
				<div class="header">
					<div class="block-view"></div>
					<div class="text-view">
						<span>康复服务 / </span>Rehabilitation Services
					</div>
				</div>
				<div class="section">
					<div class="title">在院/居家康复护理包</div>
					<div class="count">
						根据患者的功能障碍情况，照护师通过日常生活能力的训练，肌力增强训练和耐力训练等训练，配以相应的器械，达到身体机能恢复，生活自理，生存质量的提高。
					</div>
					<div class="title">术后康复</div>
					<div class="count">
						预防并发症，恢复手术器官的功能，增强免疫力，使患者适应新的生活条件和与他人互动，以及心理支持。
					</div>
				</div>
			</div>
			<img class="right-view" src="images/home-section5-pc-01.png" alt="">
		</div>
		<div id="anchorPoint4"></div>
		<div class="home-section6">
			<div class="left-view">
				<div class="item">
					<img src="images/home-section6-pc-01.png" alt="">
				</div>
				<div class="item">
					<img src="images/home-section6-pc-02.png" alt="">
				</div>
				<div class="item">
					<img src="images/home-section6-pc-03.png" alt="">
				</div>
				<div class="item">
					<img src="images/home-section6-pc-04.png" alt="">
				</div>
			</div>
			<div class="right-view">
				<div class="line"></div>
				<div class="text-view">
					<div class="header">
						<span>养老服务 / </span>Elderly Services
					</div>
					<div class="section">社区/居家养老</div>
					<div class="footer">
						入浴辅助，进餐辅助，变换体位，起床/就寝辅助，排泄辅助，更衣辅助，生活照护。
					</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint5"></div>
		<div class="home-section7">
			<img class="aside" src="images/home-section7-pc-01.jpg" alt="">
			<div class="section">
				<div class="header">
					<span>护理服务托管 / </span>Nursing Service Trusteeship
				</div>
				<div class="section">
					<div class="list-view">
						<div class="title">护理服务托管内容</div>
						<div class="item">整体护理服务托管</div>
						<div class="item">服务管理</div>
						<div class="item">护工管理</div>
						<div class="item">技能培训</div>
					</div>
					<div class="line"></div>
					<div class="list-view">
						<div class="title">护理服务托管合作机构</div>
						<div class="item">综合性医院</div>
						<div class="item">康复医院</div>
						<div class="item">护理院</div>
						<div class="item">整形医院</div>
					</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint6"></div>
		<div class="home-section8">
			<img class="aside" src="images/home-section8-pc-01.jpg" alt="">
			<div class="section">
				<div class="header">
					<span>职业技能培训 / </span>Vocational Skills Training
				</div>
				<div class="section">
					职业资格证书培训<br />
					养老护理证、健康照护证、母婴护理证、育婴证
				</div>
				<div class="section aside">
					在线技能培训<br />基础素养、技能提升、护理技巧、岗前培训
				</div>
				<div class="footer"></div>
			</div>
		</div>
		<div class="home-section9">
			<div class="header">合作伙伴</div>
			<div class="aside">创新，务实，责任，共赢</div>
			<div class="section1">
				<img src="images/home-section9-pc-01.png" alt="">
				<img src="images/home-section9-pc-02.png" alt="">
				<img src="images/home-section9-pc-03.png" alt="">
				<img src="images/home-section9-pc-04.png" alt="">
			</div>
			<div class="section2">
				<img src="images/home-section9-pc-05.png" alt="">
				<img src="images/home-section9-pc-06.png" alt="">
				<img src="images/home-section9-pc-07.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: "HomePC",
		methods:{
			scrollToDomFun(domeId){
				var scrollTop = document.getElementById(domeId).offsetTop;
				util.scrollTo(scrollTop);
			}
		},
		mounted() {
			let homeSection1 = new Swiper('.home-section1', {
				loop: true,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				pagination: {
				    el: '.swiper-pagination',
					clickable :true,
				  },
			});
		}
	}
</script>

<style scoped="scoped">
	.home-section>.home-section1 {
		position: relative;
		width: 100%;
	}
	
	.home-section>.home-section1 img {
		width: 100%;
		display: block;
	}
	.home-section>.home-section1 .swiper-pagination{
		text-align: right;
		padding-right: 0.32rem;
		box-sizing: border-box;
	}
	.home-section>.home-section2,
	.home-section>.home-section3,
	.home-section>.home-section4,
	.home-section>.home-section5,
	.home-section>.home-section6,
	.home-section>.home-section7,
	.home-section>.home-section8,
	.home-section>.home-section9{
		width: 12rem;
		position: relative;
		margin: 1.6rem auto 0 auto;
	}
	.home-section>.home-section2>.header{
		text-align: center;
		font-size:0.42rem;
		font-family: YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color: #333333;
	}
	.home-section>.home-section2>.aside{
		text-align: center;
		font-size:0.24rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
		margin-top: 0.18rem;
	}
	.home-section>.home-section2>.section{
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.home-section>.home-section2>.section>.item{
		width: 3.6rem;
		height: 2.4rem;
		margin: 0.6rem 0 0 0.6rem;
		flex-shrink: 0;
		background:rgba(71,136,244,0.8);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.home-section>.home-section2>.section>.item:nth-of-type(3n+1){
		margin-left: 0;
	}
	.home-section>.home-section2>.section>.item>.header{
		font-size:0.6rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.2;
		color: #FFFFFF;
		text-align: center;
	}
	.home-section>.home-section2>.section>.item>.section{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color: #FFFFFF;
		margin-top: 0.12rem;
		text-align: center;
	}
	.home-section>.home-section2>.section>.item>.footer{
		font-size:0.12rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.2;
		color: #FFFFFF;
		margin-top: 0.06rem;
		text-align: center;
	}
	.home-section>.home-section3{
		position: relative;
	}
	.home-section>.home-section3>.left-view{
		width: 7.2rem;
		flex-shrink: 0;
	}
	.home-section>.home-section3>.left-view>img{
		width: 100%;
		display: block;
	}
	.home-section>.home-section3>.right-view{
		position: absolute;
		top: 50%;
		right: 0;
		z-index: 2;
		width:5.32rem;
		background:#4788F4;
		transform: translateY(-50%);
		padding: 0.64rem 0.48rem 0.64rem 0.64rem;
		box-sizing: border-box;
	}
	.home-section>.home-section3>.right-view>.header{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color:#FFFFFF;
	}
	.home-section>.home-section3>.right-view>.header>span{
		font-weight: bold;
	}
	.home-section>.home-section3>.right-view>.section{
		margin-top: 0.18rem;
	}
	.home-section>.home-section3>.right-view>.section>.item{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 0.12rem 0;
		box-sizing: border-box;
	}
	.home-section>.home-section3>.right-view>.section>.item>.line{
		width: 0.04rem;
		background: #FFCC1E;
		flex-shrink: 0;
		margin-right: 0.08rem;
		height: 100%;
		height: 0.2rem;
	}
	.home-section>.home-section3>.right-view>.section>.item>.text{
		font-size:0.2rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color: #FFFFFF;
		width: 0.01rem;
		flex: 1 1 auto;
	}
	.home-section>.home-section4{
		width: 100%;
		position: relative;
	}
	.home-section>.home-section4>.aside{
		width: 100%;
		display: block;
	}
	.home-section>.home-section4>.header{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
	}
	.home-section>.home-section4>.header>.left-view{
		width: 0.01rem;
		flex: 1 0 auto;
		height: 100%;
		background:rgba(71,136,244,0.78);
	}
	.home-section>.home-section4>.header>.right-view{
		width: 2.01rem;
		height: 100%;
		flex: 1 0 auto;
		overflow: hidden;
		position: relative;
		background: rgba(255,255,255, 0.25);
	}
	.home-section>.home-section4>.section{
		position: absolute;
		top: 50%;
		left: 50%;
		width: 12rem;
		z-index: 9;
		transform: translate(-50%, -50%);
	}
	.home-section>.home-section4>.section>.left-view{
		width: 4rem;
	}
	.home-section>.home-section4>.section>.left-view>.header{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color:#FFFFFF;
	}
	.home-section>.home-section4>.section>.left-view>.header>span{
		font-weight: bold;
	}
	.home-section>.home-section4>.section>.left-view>.section{
		font-size:0.2rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color: #FFFFFF;
		margin-top: 0.24rem;
	}
	.home-section>.home-section4>.section>.left-view>.footer{
		width:0.83rem;
		height:0.02rem;
		margin-top: 0.72rem;
		background: #FFFFFF;
	}
	.home-section>.home-section4>.section>.right-view{
		width:9.73rem;
		position: absolute;
		top: 50%;
		left: 4rem;
		padding: 0.64rem 1.8rem 0.64rem 1.2rem;
		box-sizing: border-box;
		transform: translateY(-50%);
		background:rgba(255,255,255,0.86);
	}
	.home-section>.home-section4>.section>.right-view>.item{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 0.36rem;
	}
	.home-section>.home-section4>.section>.right-view>.item:nth-last-of-type(1){
		margin-bottom: 0;
	}
	.home-section>.home-section4>.section>.right-view>.item>.left-view{
		width:1.36rem;
		flex-shrink: 0;
	}
	.home-section>.home-section4>.section>.right-view>.item>.right-view{
		width: 0.01rem;
		flex: 1 1 auto;
		margin-left: 0.24rem;
	}
	.home-section>.home-section4>.section>.right-view>.item>.right-view>.header{
		font-size:0.24rem;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height:1.5;
		color:#333333;
	}
	.home-section>.home-section4>.section>.right-view>.item>.right-view>.section{
		margin-top: 0.16rem;
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#333333;
	}
	.home-section>.home-section5{
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}
	.home-section>.home-section5>.left-view{
		width: 8rem;
		box-sizing: border-box;
		padding: 1.35rem 0 2.1rem 0;
		position: relative;
		z-index: 2;
	}
	.home-section>.home-section5>.left-view>.header{
		position: relative;
		display: flex;
	}
	.home-section>.home-section5>.left-view>.header>.block-view{
		width:1.54rem;
		height:1.05rem;
		border:0.05rem solid #4788F4;
		position: absolute;
		top: 50%;
		left: 0;
		z-index: 2;
		transform: translate(-50%,-50%);
	}
	.home-section>.home-section5>.left-view>.header>.text-view{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:2;
		color:#333333;
		background: #FFFFFF;
		position: relative;
		z-index: 3;
	}
	.home-section>.home-section5>.left-view>.header>.text-view>span{
		font-weight: bold;
	}
	.home-section>.home-section5>.left-view>.section>.title{
		font-size:0.24rem;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height:1.3;
		color: #333333;
		margin-top: 0.54rem;
	}
	.home-section>.home-section5>.left-view>.section>.count{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#333333;
		margin-top: 0.3rem;
	}
	.home-section>.home-section5>.right-view{
		width: 6.45rem;
		flex-shrink: 0;
	}
	.home-section>.home-section6{
		display: flex;
		width: 100%;
		justify-content: flex-start;
		position: relative;
	}
	.home-section>.home-section6>.left-view{
		width: 50%;
		flex-shrink: 0;
		display: flex;
		flex-wrap: wrap;
	}
	.home-section>.home-section6>.left-view>.item{
		width: 34%;
		flex: 1 0 auto;
		margin: 0.2rem 0 0 0.2rem;
	}
	.home-section>.home-section6>.left-view>.item>img{
		width: 100%;
		display: block;
	}
	.home-section>.home-section6>.left-view>.item:nth-of-type(1),
	.home-section>.home-section6>.left-view>.item:nth-of-type(2){
		margin-top: 0;
	}
	.home-section>.home-section6>.left-view>.item:nth-of-type(2n+1){
		margin-left: 0;
	}
	.home-section>.home-section6>.right-view{
		width: 50%;
		flex-shrink: 0;
		height: 100%;
		background: #4788F4;
		display: flex;
		align-items: center;
		padding: 0 1.4rem;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		right: 0;
	}
	.home-section>.home-section6>.right-view>.text-view{
		position: relative;
		z-index: 9;
		background: #4788F4;
		padding: 0.72rem 0 0.88rem 0;
		box-sizing: border-box;
		width: 4rem;
	}
	.home-section>.home-section6>.right-view>.text-view>.header{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color:#FFFFFF;
	}
	.home-section>.home-section6>.right-view>.text-view>.header>span{
		font-weight: bold;
	}
	.home-section>.home-section6>.right-view>.text-view>.section{
		font-size:0.24rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color:#FFFFFF;
		margin-top: 0.3rem;
	}
	.home-section>.home-section6>.right-view>.text-view>.footer{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#FFFFFF;
		margin-top: 0.2rem;
	}
	.home-section>.home-section6>.right-view>.line{
		width:4.46rem;
		height:4.59rem;
		border:0.05rem solid rgba(242,242,242,1);
		position: absolute;
		top:50%;
		left: 2rem;
		z-index: 2;
		transform: translateY(-50%);
	}
	.home-section>.home-section7{
		position: relative;
	}
	.home-section>.home-section7>.aside{
		width: 100%;
		display: block;
	}
	.home-section>.home-section7>.section{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9;
		background:rgba(71,136,244,0.92);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.home-section>.home-section7>.section>.header{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color:#FFFFFF;
	}
	.home-section>.home-section7>.section>.header>span{
		font-weight: bold;
	}
	.home-section>.home-section7>.section>.section{
		margin-top: 0.4rem;
		padding: 0.32rem 0;
		box-sizing: border-box;
		border: 0.01rem solid #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.home-section>.home-section7>.section>.section>.list-view{
		width: 2.84rem;
		flex-shrink: 0;
		padding-left: 0.54rem;
		box-sizing: border-box;
	}
	.home-section>.home-section7>.section>.section>.list-view>.title{
		font-size:0.2rem;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height:1.3;
		color: #FFFFFF;
		margin-bottom: 0.12rem;
	}
	.home-section>.home-section7>.section>.section>.list-view>.item{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:2.3;
		color: #FFFFFF;
	}
	.home-section>.home-section7>.section>.section>.line{
		width: 0.01rem;
		height: 75%;
		background: #FFFFFF;
		flex-shrink: 0;
	}
	.home-section>.home-section8{
		position: relative;
		width: 100%;
	}
	.home-section>.home-section8>.aside{
		width: 100%;
		display: block;
	}
	.home-section>.home-section8>.section{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-25%,-50%);
		padding: 1.4rem 1.2rem;
		box-sizing: border-box;
		background:rgba(71,136,244,0.78);
	}
	.home-section>.home-section8>.section>.header{
		font-size:0.3rem;
		font-family:Microsoft YaHei;
		font-weight:300;
		line-height:1.3;
		color:#FFFFFF;
	}
	.home-section>.home-section8>.section>.header>span{
		font-weight: bold;
	}
	.home-section>.home-section8>.section>.section{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#FFFFFF;
		margin-top: 0.3rem;
	}
	.home-section>.home-section8>.section>.aside{
		margin-top: 0.18rem;
	}
	.home-section>.home-section8>.section>.footer{
		width:0.83rem;
		height:0.02rem;
		margin-top: 0.52rem;
		background: #FFFFFF;
	}
	.home-section>.home-section9{
		width: 100%;
	}
	.home-section>.home-section9>.header{
		text-align: center;
		font-size:0.42rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color: #333333;
	}
	.home-section>.home-section9>.aside{
		font-size:0.24rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color: #333333;
		text-align: center;
		margin-top: 0.18rem;
		text-align: center;
	}
	.home-section>.home-section9>.section1,
	.home-section>.home-section9>.section2{
		margin-top: 0.96rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.home-section>.home-section9>.section1>img,
	.home-section>.home-section9>.section2>img{
		flex-shrink: 0;
	}
	.home-section>.home-section9>.section1>img:nth-of-type(1),
	.home-section>.home-section9>.section2>img:nth-of-type(1){
		margin-left: 0;
	}
	.home-section>.home-section9>.section1>img{
		margin-left: 1.1rem;
	}
	.home-section>.home-section9>.section1>img:nth-of-type(1){
		width: 1.6rem;
		transform: translateY(0.25rem);
	}
	.home-section>.home-section9>.section1>img:nth-of-type(2){
		width: 1.60rem;
	}
	.home-section>.home-section9>.section1>img:nth-of-type(3){
		width: 1.71rem;
	}
	.home-section>.home-section9>.section1>img:nth-of-type(4){
		width: 2.95rem;
		transform: translateY(0.3rem);
	}
	.home-section>.home-section9>.section2{
		margin-top: 0;
	}
	.home-section>.home-section9>.section2>img{
		margin-left: 0.48rem;
	}
	.home-section>.home-section9>.section2>img:nth-of-type(1){
		width: 4.08rem;
		transform: translateY(-0.20rem);
	}
	.home-section>.home-section9>.section2>img:nth-of-type(2){
		width: 3.66rem;
	}
	.home-section>.home-section9>.section2>img:nth-of-type(3){
		width: 3.21rem;
	}
</style>

<style>
	.swiper-pagination-clickable .swiper-pagination-bullet{
		background: #FFFFFF;
		opacity: 0.45;
		width: 0.16rem;
		height: 0.16rem;
		border-radius: 50%;
		transition: width 200ms linear;
	}
	.swiper-pagination-clickable .swiper-pagination-bullet-active{
		background: #FFFFFF;
		opacity: 1;
		width: 0.48rem;
		border-radius: 0.08rem;
	}
</style>